export const environment = {
  production: true,
  baseURL: 'https://volga.com.co'
};
